import BasePage from "../../../base/BasePage";
import React from "react";
import { addSchemaUseCase } from "../../../usecases/schema/usecases";
import TrainingPresenter from "./TrainingPresenter";
import CardView from "../../../components/common/CardView";
import RegionTab from "../../../components/common/RegionTab";
import AvailableTrainingPage from "./ESS-Training-Table/AvailableTrainingPage";
import MyTrainingPage from "./ESS-Training-Table/MyTrainingPage";
import ExternalTrainingPage from "./ESS-Training-Table/ExternalTrainingPage";

class TrainingPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Available Trainings", content: <AvailableTrainingPage /> },
      { title: "My Trainings", content: <MyTrainingPage /> },
      { title: "External Trainings", content: <ExternalTrainingPage /> },
    ];

    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Employee Self-service &gt;{" "}
              <span style={{ color: "#333" }}>Training</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default TrainingPage;
